define([
  "jquery",
  "marionette",
  "messaging/messenger",
  "underscore",
  "./topicCopyResponseLocaleAndTouchpointView",
  "modules/shared/treeList/treeListModule",
  "modules/shared/treeList/treeListModel",
  "modules/topicsSplit/topic/topicResponse/topicResponseModel",
], function (
  $,
  Marionette,
  Messenger,
  _,
  TopicCopyResponseLocaleAndTouchpointView,
  TreeListModule,
  TreeListModel,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicCopyResponseModal";
      this.namespace = options.namespace;
      this.namespacePrefix = this.namespace ? this.namespace + ":" : "";
    },
    show: function (dataBundle) {
      this.sourceConversation = dataBundle.conversation;
      this.conversation = dataBundle.selectedConversation;
      this.sourceResponseTemplate = dataBundle.sourceResponseTemplate;
      this.touchPoints = Messenger.reqres.request("kb:touchpoints");
      this.locales = Messenger.reqres.request("kb:languages");
      this.layout = new TopicCopyResponseLocaleAndTouchpointView.localeAndTouchpointView({
        model: this.conversation,
      });
      this.root = this._buildModel(this.conversation, this.touchPoints, this.locales);
      this.copyResponsesList = this.addSubModule(
        new TreeListModule({
          region: this.layout.copyResponseList,
          namespace: this.name,
        }),
      );

      this.layout.on("selectAll", this._onSelectAll, this);
      this.layout.on("deselectAll", this._onDeselectAll, this);
      this.layout.on("show", this._onShow, this);

      this.showRegion(this.layout);
    },
    _buildModel: function (conversation, touchPoints, locales) {
      const treeData = [];
      locales.forEach((locale) => {
        const node = {
          name: locale.get("name"),
          data: locale.get("id"),
          nodes: [],
        };
        const languageId = locale.get("id");
        touchPoints.forEach((touchPoint) => {
          const touchPointId = touchPoint.get("touchPointId");
          const responseTemplate = conversation.findResponseTemplate(touchPointId, languageId);
          if (!responseTemplate || responseTemplate.isEmpty()) {
            node.nodes.push({
              name: touchPoint.get("touchPoint"),
              data: languageId + "_" + touchPointId,
            });
          }
        });
        if (node.nodes.length > 0) {
          treeData.push(node);
        }
      });
      return new TreeListModel.collection(treeData);
    },
    copyResponses: function (selectedResponses) {
      const sourceResponse = this.sourceResponseTemplate.get("response");
      const targetResponse = this._stripCkEditorMarkup(sourceResponse);
      selectedResponses.forEach((selectedResponse) => {
        // Selected languages will only contain the language ID as a number
        if (typeof selectedResponse != "string") {
          return;
        }
        const parts = selectedResponse.split("_");
        if (parts.length < 2) {
          return;
        }
        const languageId = parseInt(parts[0], 10);
        const touchPointId = parseInt(parts[1], 10);
        if (this.sourceConversation.get("intentId") !== this.conversation.get("intentId")) {
          this.conversation.setResponse(touchPointId, languageId, targetResponse, { silent: true });
        } else {
          this.conversation.setResponse(touchPointId, languageId, targetResponse);
        }
      });
      if (this.sourceConversation.get("intentId") !== this.conversation.get("intentId")) {
        this.conversation.saveModel();
      }
    },
    _onDeselectAll: function () {
      Messenger.vent.trigger(this.name + ":treeList:deselect:all");
    },
    _onSelectAll: function () {
      Messenger.vent.trigger(this.name + ":treeList:select:all");
    },
    _onShow: function () {
      this.layout.hideError();
      this._showSubViews();
    },
    _showSubViews: function () {
      this.copyResponsesList.show({ model: this.root });
    },
    _stripCkEditorMarkup: function (response) {
      const el = $(`<div class="hidden">${response}</div>`);
      for (const tag of ["comment-start", "comment-end", "suggestion-start", "suggestion-end"]) {
        el.find(tag).remove();
      }
      for (const attribute of [
        "data-comment-start-before",
        "data-comment-end-after",
        "data-comment-start-after",
        "data-comment-end-before",
        "data-suggestion-start-before",
        "data-suggestion-end-after",
        "data-suggestion-start-after",
        "data-suggestion-end-before",
      ]) {
        const els = el.find(`*[${attribute}]`);
        els.removeAttr(attribute);
      }
      const strippedResponse = el[0].innerHTML;
      el.remove();
      return strippedResponse;
    },
  });
});
